import React, {PureComponent} from "react";
import $ from "jquery";
import {formatTime} from "../functions/utils";
import {Modal} from 'react-responsive-modal';
import {
    confirmIdentity,
    connectSocket,
    subscribeDashToServer,
    subscribeToStandingsInfo,
    closeSocket
} from "../functions/api";

import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;
let counter = 0;

class PopoutLiveMaxes extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            carList: [{
                device_id: -1,
                id: -1,
                team_name: "---",
                short_name: "---",
                livery_number: "---",
                laps: {
                    rpm: [],
                    rpmThr: [],
                    speedGPS: [],
                    speedOBD: [],
                },
            }],
            tableRows: [<tr key={-1}/>,],
            modalData: [{
                uuid: "",
            }],
            show: false,
            orderSwitch: false,
            confirmedOrg: true,
            searchVehicle: "",
        };

        this.makeTableRows = this.makeTableRows.bind(this);
        this.getData = this.getData.bind(this);
        this.popoutDetail = this.popoutDetail.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);

        this.handleChangeSort = this.handleChangeSort.bind(this);
        this.compareNr = this.compareNr.bind(this);
        this.compareBestLap = this.compareBestLap.bind(this);
        this.compareSpeedOBD = this.compareSpeedOBD.bind(this);
        this.compareSpeedGPS = this.compareSpeedGPS.bind(this);
        this.compareRPM = this.compareRPM.bind(this);
        this.compareRPMThr = this.compareRPMThr.bind(this);
        this.compareRaceStatus = this.compareRaceStatus.bind(this);
        this.handleChangeVehicleSearch = this.handleChangeVehicleSearch.bind(this);
    }

    /* LIFECYCLE */
    componentDidMount() {
        $(".loading").fadeIn();
        confirmIdentity(this.props.cookies.get("authToken"), this.props.match.params.userID, this.props.match.params.eventID, (confirmed) => {
            if (confirmed) {
                // Connect Socket
                connectSocket(this.props.cookies.get("authToken"), null, this.props.match.params.sessionID, this.props.match.params.eventID, "LIVEMAXES", (msg) => {
                    console.log("[LIVE MAXES]" + msg);
                    // DS
                    subscribeDashToServer(this.props.match.params.eventID, this.props.match.params.sessionID, () => {
                        console.log("[LIVE MAXES.JS] DEDICATED STREAM SUBSCRIBED");
                    });

                    // Subscribe to standings info
                    subscribeToStandingsInfo(this.props.match.params.eventID, false, (err, standings) => {
                        counter++;
                        if (counter > 50) {
                            console.log("[LIVE MAXES.JS] UPDATED MAXES");
                            this.getData();
                            counter = 0;
                        }
                    });
                });

                this.getData();

            } else {
                this.setState({
                    confirmedOrg: false,
                });
            }
        });
    }

    componentWillUnmount() {
        subscribeDashToServer(this.props.match.params.eventID, this.props.match.params.sessionID, () => {
            console.log("[DASHBOARD] DEDICATED STREAM UNSUBSCRIBED");
        });
        subscribeToStandingsInfo(this.props.location.state.eventID, true, null);
        closeSocket();
    }

    /* GET DATA */
    getData() {
        const helper = this;
        $.ajax({
            type: "POST",
            url: serverIP + ":" + backendPort + "/dashboard/getCarListLiveMaxes",
            dataType: "json",
            headers: {

                "authorization": helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
            },
            success: function (data) {
                helper.setState({
                    carList: data,
                }, () => {
                    helper.state.carList.sort(helper.compareBestLap);
                    helper.state.carList.sort(helper.compareRaceStatus);
                    helper.makeTableRows();
                });
            },
            error: function (err) {
                if (err) {
                    console.error("Error:", err);
                }
            }
        }).done(function () {
            console.log("[LIVE MAXES.JS] COMPLETE getCarListLiveMaxes");
        });
    }

    /* HANDLERS */
    handleShowModal(e) {
        let parts = e.target.value.split("_");
        let action = parts[0];
        let index = parts[1];
        switch (action) {
            case "speedOBD": {
                this.setState({
                    modalData: this.state.carList[index].laps.speedOBD,
                }, () => {
                    this.setState({
                        show: true,
                    });
                });
                break;
            }
            case "speedGPS": {
                this.setState({
                    modalData: this.state.carList[index].laps.speedGPS,
                }, () => {
                    this.setState({
                        show: true,
                    });
                });
                break;
            }
            case "rpm": {
                this.setState({
                    modalData: this.state.carList[index].laps.rpm,
                }, () => {
                    this.setState({
                        show: true,
                    });
                });
                break;
            }
            case "rpmThr": {
                this.setState({
                    modalData: this.state.carList[index].laps.rpmThr,
                }, () => {
                    this.setState({
                        show: true,
                    });
                });
                break;
            }
            default: {
                break;
            }
        }
    }

    handleCloseModal() {
        this.setState({
            show: false,
        });
    }

    handleChangeSort(e) {
        switch (e.target.id) {
            case "bestLap": {
                this.state.carList.sort(this.compareBestLap);
                if (this.state.orderSwitch) {
                    this.state.carList.reverse();
                }
                this.setState({
                    orderSwitch: !this.state.orderSwitch,
                }, () => {
                    this.state.carList.sort(this.compareRaceStatus);
                    this.makeTableRows();
                });
                break;
            }
            case "nr": {
                this.state.carList.sort(this.compareNr);
                if (this.state.orderSwitch) {
                    this.state.carList.reverse();
                }
                this.setState({
                    orderSwitch: !this.state.orderSwitch,
                }, () => {
                    this.makeTableRows();
                });
                break;
            }
            case "speedOBD": {
                this.state.carList.sort(this.compareSpeedOBD);
                if (this.state.orderSwitch) {
                    this.state.carList.reverse();
                }
                this.setState({
                    orderSwitch: !this.state.orderSwitch,
                }, () => {
                    this.state.carList.sort(this.compareRaceStatus);
                    this.makeTableRows();
                });
                break;
            }
            case "speedGPS": {
                this.state.carList.sort(this.compareSpeedGPS);
                if (this.state.orderSwitch) {
                    this.state.carList.reverse();
                }
                this.setState({
                    orderSwitch: !this.state.orderSwitch,
                }, () => {
                    this.state.carList.sort(this.compareRaceStatus);
                    this.makeTableRows();
                });
                break;
            }
            case "rpm": {
                this.state.carList.sort(this.compareRPM);
                if (this.state.orderSwitch) {
                    this.state.carList.reverse();
                }
                this.setState({
                    orderSwitch: !this.state.orderSwitch,
                }, () => {
                    this.state.carList.sort(this.compareRaceStatus);
                    this.makeTableRows();
                });
                break;
            }
            case "rpmThr": {
                this.state.carList.sort(this.compareRPMThr);
                if (this.state.orderSwitch) {
                    this.state.carList.reverse();
                }
                this.setState({
                    orderSwitch: !this.state.orderSwitch,
                }, () => {
                    this.state.carList.sort(this.compareRaceStatus);
                    this.makeTableRows();
                });
                break;
            }
            default: {
                break;
            }
        }
    }

    handleChangeVehicleSearch(e) {
        e.preventDefault();
        if (!isNaN(e.target.value)) {
            let number = e.target.value;
            this.setState({
                searchVehicle: number,
            }, () => {
                this.makeTableRows();
            });
        }
    }

    /* SORTING METHODS */
    compareNr(a, b) {
        if (a.livery_number === 0 || b.livery_number === 0) {
            if (a.livery_number === 0) {
                return 1;
            } else if (b.livery_number === 0) {
                return -1;
            }
        } else if (a.livery_number < b.livery_number) {
            return -1;
        } else if (a.livery_number > b.livery_number) {
            return 1;
        }
    }

    compareBestLap(a, b) {
        if (a.min_time === 0 || b.min_time === 0) {
            if (a.min_time === 0) {
                return 1;
            } else if (b.min_time === 0) {
                return -1;
            }
        } else if (a.min_time < b.min_time) {
            return -1;
        } else if (a.min_time > b.min_time) {
            return 1;
        }
    }

    compareSpeedOBD(a, b) {
        if (a.max_speed_obd === 0 || b.max_speed_obd === 0) {
            if (a.max_speed_obd === 0) {
                return 1;
            } else if (b.max_speed_obd === 0) {
                return -1;
            }
        } else if (a.max_speed_obd < b.max_speed_obd) {
            return -1;
        } else if (a.max_speed_obd > b.max_speed_obd) {
            return 1;
        }
    }

    compareSpeedGPS(a, b) {
        if (a.max_speed_gps === 0 || b.max_speed_gps === 0) {
            if (a.max_speed_gps === 0) {
                return 1;
            } else if (b.max_speed_gps === 0) {
                return -1;
            }
        } else if (a.max_speed_gps < b.max_speed_gps) {
            return -1;
        } else if (a.max_speed_gps > b.max_speed_gps) {
            return 1;
        }
    }

    compareRPM(a, b) {
        if (a.max_rpm === 0 || b.max_rpm === 0) {
            if (a.max_rpm === 0) {
                return 1;
            } else if (b.max_rpm === 0) {
                return -1;
            }
        } else if (a.max_rpm < b.max_rpm) {
            return -1;
        } else if (a.max_rpm > b.max_rpm) {
            return 1;
        }
    }

    compareRPMThr(a, b) {
        if (a.max_throttled_rpm === 0 || b.max_throttled_rpm === 0) {
            if (a.max_throttled_rpm === 0) {
                return 1;
            } else if (b.max_throttled_rpm === 0) {
                return -1;
            }
        } else if (a.max_throttled_rpm < b.max_throttled_rpm) {
            return -1;
        } else if (a.max_throttled_rpm > b.max_throttled_rpm) {
            return 1;
        }
    }

    compareRaceStatus(a, b) {
        if (a.rsi < b.rsi) {
            return -1;
        } else if (a.rsi > b.rsi) {
            return 1;
        }
    }

    /* POPOUT */
    popoutDetail(e) {
        e.preventDefault();
        window.open(
            "/lapDetails/" + this.props.match.params.eventID + "/" + this.props.match.params.sessionID + "/" + e.target.value,
            "lapDetail",
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=100,top=100,height=750,width=900"
        );
    }

    /* RENDER */
    makeTableRows() {
        let rows = [];
        for (let car = 0; car < this.state.carList.length; car++) {
            if (!isNaN(parseInt(this.state.searchVehicle))) {
                if (("" + this.state.carList[car].livery_number).indexOf(this.state.searchVehicle) === -1) {
                    continue;
                }
            }

            let statusColor = "";
            let statusText = "";
            let statusOpacity = "";

            switch (this.state.carList[car].rsi) {
                case (2): {
                    statusColor = "#be2000";
                    statusText = "DNF - ";
                    statusOpacity = "40";
                    break;
                }
                case (3): {
                    statusColor = "#e09d00";
                    statusText = "DNS - ";
                    statusOpacity = "40";
                    break;
                }
                default: {
                    statusColor = "";
                    statusText = "";
                    statusOpacity = "";
                    break;
                }
            }

            rows.push(
                <tr
                    key={this.state.carList[car].livery_number}
                    className={"onHover App_white_text_liveMaxes"}
                    style={{textAlign: "center", whiteSpace: "nowrap", backgroundColor: (statusColor + statusOpacity)}}
                >
                    <td style={{
                        width: "5%",
                    }}>#{this.state.carList[car].livery_number}</td>
                    <td style={{
                        width: "20%",
                        textAlign: "left"
                    }}>{statusText + this.state.carList[car].team_name}</td>
                    <td>
                        {this.state.carList[car].laps.bestLap ? (
                            <button
                                style={{background: "#ff0003", fontWeight: "bold"}}
                                type={"button"}
                                className={"btn App_white_text_liveMaxes button"}
                                value={this.state.carList[car].laps.bestLap[0].uuid}
                                onClick={this.popoutDetail}
                                disabled={!this.state.carList[car].min_time}
                            >
                                {this.state.carList[car].min_time ? formatTime(this.state.carList[car].min_time) : "--:--:--"}
                            </button>
                        ) : (
                            <button
                                style={{background: "#ff0003", fontWeight: "bold"}}
                                type={"button"}
                                className={"btn App_white_text_liveMaxes button"}
                                disabled={true}
                            >
                                --:--:--
                            </button>
                        )}
                    </td>
                    <td>
                        <button
                            key={car.id}
                            style={{background: "#ff0003", fontWeight: "bold", margin: 2}}
                            type={"button"}
                            className={"btn App_white_text_liveMaxes button"}
                            value={"speedOBD_" + car}
                            onClick={this.handleShowModal}
                            disabled={!this.state.carList[car].max_speed_obd}
                        >
                            {this.state.carList[car].max_speed_obd ? this.state.carList[car].max_speed_obd + " km/h" : "---"}
                        </button>
                    </td>
                    <td>
                        <button
                            key={car.id}
                            style={{background: "#ff0003", fontWeight: "bold", margin: 2}}
                            type={"button"}
                            className={"btn App_white_text_liveMaxes button"}
                            value={"speedGPS_" + car}
                            onClick={this.handleShowModal}
                            disabled={!this.state.carList[car].max_speed_gps}
                        >
                            {this.state.carList[car].max_speed_gps ? this.state.carList[car].max_speed_gps + " km/h" : "---"}
                        </button>
                    </td>
                    <td>
                        <button
                            key={car.id}
                            style={{background: "#ff0003", fontWeight: "bold", margin: 2}}
                            type={"button"}
                            className={"btn App_white_text_liveMaxes button"}
                            value={"rpm_" + car}
                            onClick={this.handleShowModal}
                            disabled={!this.state.carList[car].max_rpm}
                        >
                            {this.state.carList[car].max_rpm ? this.state.carList[car].max_rpm + " RPM" : "---"}
                        </button>
                    </td>
                    <td>
                        <button
                            key={car.id}
                            style={{background: "#ff0003", fontWeight: "bold", margin: 2}}
                            type={"button"}
                            className={"btn App_white_text_liveMaxes button"}
                            value={"rpmThr_" + car}
                            onClick={this.handleShowModal}
                            disabled={!this.state.carList[car].max_throttled_rpm}
                        >
                            {this.state.carList[car].max_throttled_rpm ? this.state.carList[car].max_throttled_rpm + " RPM" : "---"}
                        </button>
                    </td>
                </tr>
            );
        }

        this.setState({
            tableRows: rows,
        }, () => {
            $(".loading").fadeOut();
        });
    }

    render() {
        if (this.state.confirmedOrg) {
            return (
                <div className={"table-responsive table-scroll-parent App_lapTableContainerStyle"}>
                    <div className="loading">
                        <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                    </div>
                    <div className={"table-scroll-child"}>
                        <table className={"table table-hover table-condensed"}>
                            <thead>
                            <tr>
                                <th colSpan={2}>
                                    <input
                                        className={"form-control App_black_text"}
                                        style={{border: "2px solid #ed2126", height: 40, width: "35%"}}
                                        value={this.state.searchVehicle}
                                        placeholder={"000"}
                                        type={"text"}
                                        onChange={this.handleChangeVehicleSearch}
                                    />
                                </th>
                                <th colSpan={6}/>
                            </tr>
                            <tr style={{whiteSpace: "nowrap"}}>
                                <th id={"nr"} className={"App_header"} style={{cursor: "pointer", width: "5%"}} onClick={this.handleChangeSort}><i className="fas fa-arrows-alt-v"/> {this.props.t("nr").toUpperCase()}</th>
                                <th className={"App_header"} style={{textAlign: "left"}}>TEAM</th>
                                <th id={"bestLap"} className={"App_header"} style={{cursor: "pointer"}} onClick={this.handleChangeSort}><i className="fas fa-arrows-alt-v"/> {this.props.t("bestLap").toUpperCase()}</th>
                                <th id={"speedOBD"} className={"App_header"} style={{cursor: "pointer"}} onClick={this.handleChangeSort}><i className="fas fa-arrows-alt-v"/> {(this.props.t("maxSpd") + " (OBD)").toUpperCase()}</th>
                                <th id={"speedGPS"} className={"App_header"} style={{cursor: "pointer"}} onClick={this.handleChangeSort}><i className="fas fa-arrows-alt-v"/> {(this.props.t("maxSpd") + " (GPS)").toUpperCase()}</th>
                                <th id={"rpm"} className={"App_header"} style={{cursor: "pointer"}} onClick={this.handleChangeSort}><i className="fas fa-arrows-alt-v"/> {this.props.t("maxRpm_noThr").toUpperCase()}</th>
                                <th id={"rpmThr"} className={"App_header"} style={{cursor: "pointer"}} onClick={this.handleChangeSort}><i className="fas fa-arrows-alt-v"/> {this.props.t("maxRpm_thr").toUpperCase()}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.tableRows}
                            </tbody>
                        </table>
                    </div>
                    <Modal open={this.state.show}
                           onClose={this.handleCloseModal}
                           center={false}
                           classNames={{modal: "small-modal"}}
                           showCloseIcon={false}
                    >
                        <div className={"modal-header"}>
                            <div className={"modal-title"}>
                                <b className={"App_header"} style={{color: "#000000"}}>{this.props.t("occurrences")}</b>
                            </div>
                        </div>
                        <div className={"modal-body"}>
                            <p className={"App_bold_text"} style={{color: "#000000", fontSize: 20}}>{this.props.t("clickALapToAnalyse")}</p>
                            <button
                                key={this.state.modalData[0].uuid}
                                style={{background: "#ff0003", fontWeight: "bold", margin: 2}}
                                type={"button"}
                                className={"btn App_white_text_liveMaxes button"}
                                value={this.state.modalData[0].uuid}
                                onClick={this.popoutDetail}
                            >
                                {this.props.t("lap")} {this.state.modalData[0].lap_number}
                            </button>
                            {this.state.modalData.length > 1 ? (
                                <div>
                                    <hr/>
                                    <p className={"App_bold_text"} style={{color: "#000000", fontSize: 20}}>{this.props.t("similarOccurrences")}</p>
                                    <div className={"row"}>
                                        {this.state.modalData.map((lap, index) => {
                                            if (index > 0) {
                                                return (
                                                    <div key={lap.uuid + "_div"} className={"col-xs-12 col-sm-4"} style={{padding: 2}}>
                                                        <button
                                                            key={lap.uuid}
                                                            style={{background: "#ff0003", fontWeight: "bold"}}
                                                            type={"button"}
                                                            className={"btn btn-block App_white_text_liveMaxes button"}
                                                            value={lap.uuid}
                                                            onClick={this.popoutDetail}
                                                        >
                                                            {this.props.t("lap")} {lap.lap_number} - {lap.value}
                                                        </button>
                                                    </div>
                                                );
                                            } else {
                                                return (<div key={-1}/>);
                                            }
                                        })}
                                    </div>
                                </div>
                            ) : (
                                <div/>
                            )}
                        </div>
                        <div className={"modal-footer"}>
                            <button
                                onClick={this.handleCloseModal}
                                className={"btn App_header button"}
                                style={{background: "#ff0003", color: "#FFFFFF"}}
                            >{this.props.t("close")}
                            </button>
                        </div>
                    </Modal>
                </div>
            );
        } else {
            return (
                <div/>
            );
        }
    }
}

export default withTranslation("translations")(withCookies(PopoutLiveMaxes));
